/*!
=========================================================
* Regiform IMS Frontend - UnderConstruction Component
=========================================================
* Component for displaying under construction pages
* Built with Ant Design components
=========================================================
*/
import React from "react";
import { Result, Button } from "antd";
import { ToolOutlined, HomeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "./UnderConstruction.css";

function UnderConstruction({ 
  title = "Under Construction", 
  subtitle = "This feature is currently being developed",
  showHomeButton = true 
}) {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/dashboard");
  };

  return (
    <div className="under-construction">
      <Result
        icon={<ToolOutlined className="under-construction-icon" />}
        title={title}
        subTitle={subtitle}
        extra={
          showHomeButton && (
            <Button 
              type="primary" 
              icon={<HomeOutlined />} 
              onClick={handleGoHome}
              className="under-construction-button"
            >
              Go to Dashboard
            </Button>
          )
        }
      />
    </div>
  );
}

export default UnderConstruction;
